module.exports = __webpack_public_path__ + "76ed7cb20347bd66cfb4b14ee64b5452.png";